import { api } from "../../api/apiSlice";

export const rolesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: () => ({ url: "/roles" }),
      providesTags: (result) =>
        result
          ? [
              ...result.map((r) => ({ type: "Roles", id: r.roleId })),
              { type: "Roles", id: "LIST" },
            ]
          : [{ type: "Roles", id: "LIST" }],
    }),
    getRole: builder.query({
      query: (roleId) => ({ url: `/roles/${roleId}` }),
      providesTags: (result, error, roleId) => [{ type: "Roles", id: roleId }],
    }),
    createRole: builder.mutation({
      query: (body) => ({ url: "/roles", method: "POST", data: body }),
      invalidatesTags: [{ type: "Roles", id: "LIST" }],
    }),
    renameRole: builder.mutation({
      query: ({ roleId, roleName }) => ({
        url: `/roles/${roleId}`,
        method: "PUT",
        data: { roleName },
      }),
      invalidatesTags: (result, error, { roleId }) => [
        { type: "Roles", id: roleId },
        { type: "Roles", id: "LIST" },
      ],
    }),
    deleteRole: builder.mutation({
      query: (roleId) => ({ url: `/roles/${roleId}`, method: "DELETE" }),
      invalidatesTags: [{ type: "Roles", id: "LIST" }],
    }),
    assignRolePermission: builder.mutation({
      query: ({ roleId, permissionId }) => ({
        url: `/roles/${roleId}/permissions/${permissionId}`,
        method: "POST",
      }),
      invalidatesTags: (result, error, { roleId }) => [
        { type: "Roles", id: roleId },
      ],
    }),
    removeRolePermission: builder.mutation({
      query: ({ roleId, permissionId }) => ({
        url: `/roles/${roleId}/permissions/${permissionId}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { roleId }) => [
        { type: "Roles", id: roleId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRolesQuery,
  useGetRoleQuery,
  useCreateRoleMutation,
  useRenameRoleMutation,
  useDeleteRoleMutation,
  useAssignRolePermissionMutation,
  useRemoveRolePermissionMutation,
} = rolesApi;
